var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew221({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.41,5.06A8.25,8.25,0,0,1,7.81,5a2.33,2.33,0,0,1,1.58.47A1.52,1.52,0,0,1,9.88,6.6a1.7,1.7,0,0,1-.43,1.21,2.4,2.4,0,0,1-1.73.61,2.06,2.06,0,0,1-.58-.05v2.26H6.41Zm.73,2.72a2.52,2.52,0,0,0,.6.06c.88,0,1.41-.43,1.41-1.21s-.52-1.1-1.33-1.1a3.13,3.13,0,0,0-.68.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew221);
export default __webpack_public_path__ + "static/media/Symbolpack_New_221.8f4e79635d9905b84f5a0cd3d258d3a4.svg";
export { ForwardRef as ReactComponent };